import { useQuery } from '@tanstack/react-query';

import { get } from '../../../lib/api';

/**
 * Hook to fetch audiences for the broadcast builder.
 * Uses the existing audiences endpoint which returns audiences with their
 * segment groups and calculated audience sizes.
 *
 * @returns {Array} Array of audience options formatted for react-select
 */
export const useFetchAudiences = () => {
  const { data = [] } = useQuery(['getAudiences'], () =>
    get('/api/client_admin/audiences'),
  );

  return data.map(({ id, name, audience_size, color }) => ({
    value: id,
    label: name,
    audienceSize: audience_size,
    color,
  }));
};
